'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var LifepalProvider = require('../LifepalProvider/LifepalProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function DefaultLoadingFallback() {
    return React__default['default'].createElement("p", null, "Loading...");
}
/**
 * Support client-side conditional redirecting based on the user's
 * authenticated state.
 *
 * @param WrappedComponent The component that this functionality
 * will be added to.
 * @param LoadingComponent The component that will be rendered while
 * the auth state is loading.
 * @param expectedAuth Whether the user should be authenticated for
 * the component to be rendered.
 * @param location The location to redirect to.
 */
var withAuthRedirect = function (_a) {
    var WrappedComponent = _a.WrappedComponent, _b = _a.LoadingComponent, LoadingComponent = _b === void 0 ? DefaultLoadingFallback : _b, expectedAuth = _a.expectedAuth, _c = _a.fallbackUrl, fallbackUrl = _c === void 0 ? 'https://lifepal.tech' : _c;
    var WithAuthRedirectWrapper = function (props) {
        var _a = LifepalProvider.useLifepalContext(), isAuthenticated = _a.isAuthenticated, isLoading = _a.isLoading;
        if (isLoading) {
            return React__default['default'].createElement(LoadingComponent, null);
        }
        if (expectedAuth !== isAuthenticated) {
            var win = window;
            win.location.href = fallbackUrl || 'https://lifepal.tech';
            return null;
        }
        return React__default['default'].createElement(WrappedComponent, tslib_es6.__assign({}, props));
    };
    return WithAuthRedirectWrapper;
};
/**
 * Require the user to be authenticated in order to render the component.
 * If the user isn't authenticated, forward to the given URL.
 */
var withAuth = function (WrappedComponent, fallbackUrl) {
    return withAuthRedirect({
        WrappedComponent: WrappedComponent,
        expectedAuth: true,
        fallbackUrl: fallbackUrl
    });
};

module.exports = withAuth;
//# sourceMappingURL=index.js.map
